// extracted by mini-css-extract-plugin
export default {"input":"css-bbi53vkj6l","input_labelText":"css-c7pu-HEHiJ","label__error":"css-oCgelZgR7i"};